'use client';

import { useEffect, useRef } from 'react';
import { removeGid } from '../lib';

export function OkendoProductReviews({ productGid }: { productGid: string }) {
  const formattedProductId = removeGid(productGid);
  const widgetContainer = useRef(null);

  const initialiseWidget = () =>
    window.okeWidgetApi?.initWidget(widgetContainer.current);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (window.okeWidgetApi?.initWidget) {
      initialiseWidget();
    } else {
      document.addEventListener('oke-script-loaded', initialiseWidget);
    }

    return () => {
      document.removeEventListener('oke-script-loaded', initialiseWidget);
    };
  }, [formattedProductId]);

  return (
    <div
      ref={widgetContainer}
      data-oke-widget
      data-oke-reviews-product-id={`shopify-${formattedProductId}`}
    />
  );
}
